import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Sectors } from './pages/Sectors';
import { SupplierRegistration } from './pages/SupplierRegistration';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { FAQ } from './pages/FAQ';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="w-full min-h-screen bg-navy-dark" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
          <Route path="/sectors" element={<Sectors data-id="element-12" />} data-id="element-11" />
          <Route path="/supplier-registration" element={<SupplierRegistration data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-18" />} data-id="element-17" />
          <Route path="/terms" element={<Terms data-id="element-20" />} data-id="element-19" />
          <Route path="/faq" element={<FAQ data-id="element-22" />} data-id="element-21" />
        </Routes>
        <Footer data-id="element-23" />
      </div>
    </BrowserRouter>;
}